<template>
  <article>
    <AppBanner
      title="Default Prices"
      title-alignment="text-left flex-row max-w-[1600px]"
    />

    <section class="max-w-[1600px] mx-auto container-padding flex flex-col gap-2 mt-8 mb-6">
      <AppTable
        :loading="loading"
        :if-looped-items-exist="prices?.length > 0"
        class="price-table"
      >
        <template #headings>
          <th>Style</th>
          <th>Delivery</th>
          <th>Size</th>
          <th>Type</th>
          <th>Price</th>
          <th class="sr-only" />
        </template>

        <template #rows>
          <tr
            v-for="price in prices"
            :key="price.id"
          >
            <td>{{ price?.style }}</td>
            <td>{{ price?.delivery || '-' }}</td>
            <td>{{ price?.size || '-' }}</td>
            <td>{{ price?.type || '-' }}</td>
            <td>
              {{ price?.price.toFixed(2) || '-' }}
            </td>
            <td class="text-right">
              <AppButton
                class="ml-auto btn-secondary btn-outline text-sm font-admin font-normal py-1 text-gray-600 border-gray-300 hover:text-white"
                @click="priceToEdit = price"
              >
                Edit
              </AppButton>
            </td>
          </tr>
        </template>
      </AppTable>
    </section>

    <!-- Edit Price -->
    <Transition name="fade">
      <AppModal
        v-if="priceToEdit"
        :disabled="isSubmitting"
        class="event-overview-edit-modal"
        size="xl"
        @close="handleModelClose"
      >
        <PriceForm
          :price="priceToEdit"
          :errors="errors"
          :processing="isSubmitting"
          @confirm="handleEdit"
          @close="handleModelClose"
        />
      </AppModal>
    </Transition>
  </article>
</template>

<script setup>
import { HttpStatusCode } from 'axios';
import { ref } from 'vue';

import { AppBanner, AppButton, AppModal } from '@/components/app';
import { AppTable } from '@/components/app';
import { PriceForm } from '@/components/forms/admin';
import { TableNoResults } from '@/components/tables';

import { useFormSubmit, useHttp } from '@/composables';

const { isSubmitting, errors } = useFormSubmit();

const prices = ref();
const loading = ref(false);
const priceToEdit = ref(null);

const loadPrices = async () => {
  loading.value = true;

  const response = await useHttp().get('/prices');

  if (response.statusCode === HttpStatusCode.Ok) {
    prices.value = response.data.items;
  } else {
    errors.value = response.errors;
  }

  loading.value = false;
};

loadPrices();

const handleEdit = async (event) => {
  errors.value = null;
  isSubmitting.value = true;

  const response = await useHttp().put(`/prices/${priceToEdit.value.id}`, event);

  if (response.statusCode === HttpStatusCode.Ok) {
    await loadPrices();
    priceToEdit.value = null;

  } else if (response.statusCode === HttpStatusCode.UnprocessableEntity) {
    errors.value = response.errors;
  }

  isSubmitting.value = false;
};

const handleModelClose = () => {
  priceToEdit.value = null;
  errors.value = null;
};

</script>
